import { useState } from 'react';

import BpkSelectableChip from '@skyscanner-internal/backpack-web/bpk-component-chip';
import BpkMobileScrollContainer from '@skyscanner-internal/backpack-web/bpk-component-mobile-scroll-container';
import BpkSectionHeader from '@skyscanner-internal/backpack-web/bpk-component-section-header';

import CardRail from '../CardRail';
import ThemeCard from '../ThemeCard';
import { useMBDContext } from '../common/MBD/useMBDContext';

import type { HotelTopCitiesWithFilterProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/HotelTopCitiesWithFilterProps';

import STYLES from './HotelTopCitiesWithFilter.module.scss';

const HotelTopCitiesWithFilter = ({
  description,
  sections,
  title,
}: HotelTopCitiesWithFilterProps) => {
  const { buildMBDParam, rawComponentName } = useMBDContext();
  const [activeGroupIndex, setActiveGroupIndex] = useState(0);
  const [mobileScrollerRef, setMobileScrollerRef] =
    useState<HTMLElement | null>(null);
  const hasSections = !!sections?.length;

  if (!hasSections) {
    return null;
  }

  const handleOnClickCityPill = (index: number, label: string) => {
    if (mobileScrollerRef?.scroll) {
      mobileScrollerRef?.scroll({ left: 0, behavior: 'smooth' });
    }

    setActiveGroupIndex(index);
  };

  return (
    <div
      className={STYLES.HotelTopCitiesWithFilter}
      data-tracking-element-id={rawComponentName}
      data-tracking-common-params={buildMBDParam(rawComponentName)}
    >
      <BpkSectionHeader title={title} description={description} />

      <div className={STYLES.HotelTopCitiesWithFilter__cityTabs}>
        <BpkMobileScrollContainer>
          <div className={STYLES.mobile_scroll_container_body}>
            {sections.map(({ label }, index) => (
              <BpkSelectableChip
                key={label}
                className={STYLES.HotelTopCitiesWithFilter__cityChip}
                accessibilityLabel={label}
                selected={index === activeGroupIndex}
                onClick={() => handleOnClickCityPill(index, label)}
                data-tracking-element-id={`${rawComponentName}_tab_${index}`}
                data-tracking-common-params={buildMBDParam(
                  `${rawComponentName}_tab`,
                  {
                    tab_name: label,
                  },
                )}
              >
                {label}
              </BpkSelectableChip>
            ))}
          </div>
        </BpkMobileScrollContainer>
      </div>

      <CardRail
        bottomNav
        mobileScrollerRef={(ref) => setMobileScrollerRef(ref)}
      >
        {sections[activeGroupIndex].cards.map((card, index) => (
          <ThemeCard key={card.title} index={index} {...card} />
        ))}
      </CardRail>
    </div>
  );
};

export default HotelTopCitiesWithFilter;
